import { useTranslation } from 'react-i18next';
import Dropdown from '@/components/Dropdown';
import { StartupCard } from '@/components/Cards/StartupCard/v3';
import { useGetBrandsByFundraisingId } from '@/query/queries/loan/useGetBrandsByFundraisingId';
import s from './index.module.scss';

export const Brands = ({ fundraisingID }) => {
  const { t } = useTranslation('loans');
  const { data: brands } = useGetBrandsByFundraisingId(fundraisingID);

  return (
    <div className={s.wrapper}>
      <Dropdown title={t('consumer_goods_brands_batch')} className={s.dropdown}>
        <BrandsList brands={brands || []} />
      </Dropdown>
    </div>
  );
};

const BrandsList = ({ brands, onMoreDetails }) => (
  <div className={s.container}>
    <div className={s.list}>
      {brands.map(startup => (
        <StartupCard
          key={startup.id}
          roundUp={false}
          startup={{
            ...startup,
            fundraising_goal: startup.loan_amount,
          }}
          className={s.item}
          onMoreDetails={onMoreDetails}
        />
      ))}
    </div>
  </div>
);
